// Explicit preview fixtures. These are synthetic and are never live account data.
import { ART_BASE as ASSET } from '../assets.js';

export const FIXTURE_MEMBERS = [
  {
    id: 'sara',
    name: 'Sara',
    role: 'admin',
    avatar: `${ASSET}/avatar-parent-1.jpg`,
    avatarAlt: 'Sara, parent',
    subtitle: 'sara.silva@gmail.com · that’s you',
    stats: [
      { label: 'Password + Google', pin: 'on' },
      'Approves completions',
    ],
  },
  {
    id: 'david',
    name: 'David',
    role: 'admin',
    avatar: `${ASSET}/avatar-parent-2.jpg`,
    avatarAlt: 'David, parent',
    subtitle: 'david.silva@gmail.com · joined Thu',
    stats: [
      { label: 'Password set', pin: 'on' },
      'Approves completions',
    ],
  },
  {
    id: 'maya',
    name: 'Maya',
    role: 'kid',
    age: 9,
    avatar: `${ASSET}/avatar-kid-1.jpg`,
    avatarAlt: 'Maya, age 9',
    subtitle: 'profile picker + PIN',
    stats: [
      { label: 'PIN set', tone: 'moss', pin: 'on' },
      { label: '3-day streak', tone: 'ember' },
      { label: '7 quests this week', tone: 'num' },
    ],
  },
  {
    id: 'leo',
    name: 'Leo',
    role: 'kid',
    age: 11,
    avatar: `${ASSET}/avatar-kid-2.jpg`,
    avatarAlt: 'Leo, age 11',
    subtitle: 'profile picker + PIN',
    stats: [
      { label: 'PIN set', tone: 'moss', pin: 'on' },
      { label: '5-day streak', tone: 'ember' },
      { label: '9 quests this week', tone: 'num' },
    ],
  },
  {
    id: 'finn',
    name: 'Finn',
    role: 'kid',
    age: 6,
    avatar: `${ASSET}/avatar-kid-3.jpg`,
    avatarAlt: 'Finn, age 6',
    subtitle: 'profile picker · trust mode',
    stats: [
      { label: 'No PIN — trust mode', pin: 'off' },
      { label: '2-day streak', tone: 'ember' },
      { label: '5 quests this week', tone: 'num' },
    ],
    note: 'Without a PIN, anyone at the kiosk can act as Finn. Fine for younger kids — your call.',
  },
];

export const FIXTURE_INVITE_PENDING = [
  { id: 'grandma', email: 'grandma@telus.net', sentLabel: 'sent 2d ago' },
];

export const FIXTURE_SHARE_LINK = 'chorestory.com/join/silva-9F4K2Q';

export const FIXTURE_DEVICES = [
  {
    id: 'kitchen-tablet',
    name: 'Kitchen tablet',
    previewSrc: `${ASSET}/village-hero.jpg`,
    lastSeen: '7:42 pm tonight',
    status: ['night theme', 'sound off'],
    note:
      'Displays show the ambient family board only — actions need a profile pick (60-second ' +
      'session). Theme follows local time of day.',
  },
];

export const FIXTURE_PAIR_STEPS = [
  'Device appears here for one-tap confirmation',
  'Code rotates every 10 minutes',
];

export const FIXTURE_GOALS = [
  {
    id: 'maya',
    name: 'Maya',
    avatar: `${ASSET}/avatar-kid-1.jpg`,
    goal: 'LEGO Botanical set',
    target: 20,
    percent: 31,
  },
  {
    id: 'leo',
    name: 'Leo',
    avatar: `${ASSET}/avatar-kid-2.jpg`,
    goal: 'Headphones',
    target: 35,
    percent: 60,
  },
  {
    id: 'finn',
    name: 'Finn',
    avatar: `${ASSET}/avatar-kid-3.jpg`,
    hasGoal: false,
  },
];

export const FIXTURE_GOALS_NOTE =
  'Goals surface to kids as progress candles in their Trophy Room — funded by the Save jar at ' +
  'Friday payday.';

export const familyFixture = {
  familyName: 'The Silva family', parentName: 'Sara', notifications: 3,
  members: FIXTURE_MEMBERS, invitePending: FIXTURE_INVITE_PENDING,
  shareLink: FIXTURE_SHARE_LINK, devices: FIXTURE_DEVICES, pairSteps: FIXTURE_PAIR_STEPS,
  goals: FIXTURE_GOALS, goalsNote: FIXTURE_GOALS_NOTE,
  pairCode: 'DEMO12', pairDisplayUrl: 'pair.example.test',
};
